import React, { type ReactElement } from 'react';
import DOMPurify from 'dompurify';

export function sanitiseAnswer(submittedValue: string): string {
  return DOMPurify.sanitize(submittedValue, { ALLOWED_TAGS: ['p', 'br'] });
}

type Props = {
  unsanitisedAnswer: string;
  className?: string;
};

/**
 * Returns a student's test question answer that has been santised of unwanted HTML. Used in Manage
 * Marking and Mark Response pages.
 */
export default function SanitisedAnswer({ unsanitisedAnswer, className }: Props): ReactElement {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitiseAnswer(unsanitisedAnswer)
      }}
    />
  );
}
